var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32197 10.6283L12.2667 3.35159C12.5898 2.96267 13.1707 2.8873 13.5881 3.17114C14.0417 3.4789 14.1392 4.09663 13.7876 4.52074L7.13867 12.6478C6.95961 12.8638 6.69261 12.9908 6.4323 12.9982C6.39338 13.0001 6.39338 13.0001 6.37836 13C6.10968 13 5.85069 12.8934 5.66583 12.7012L2.26081 9.17549C1.87761 8.77966 1.92348 8.15531 2.35364 7.8143C2.7496 7.49953 3.33499 7.53535 3.68595 7.89888L6.32197 10.6283Z",
    fill: "#979797"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32197 10.6283L12.2667 3.35159C12.5898 2.96267 13.1707 2.8873 13.5881 3.17114C14.0417 3.4789 14.1392 4.09663 13.7876 4.52074L7.13867 12.6478C6.95961 12.8638 6.69261 12.9908 6.4323 12.9982C6.39338 13.0001 6.39338 13.0001 6.37836 13C6.10968 13 5.85069 12.8934 5.66583 12.7012L2.26081 9.17549C1.87761 8.77966 1.92348 8.15531 2.35364 7.8143C2.7496 7.49953 3.33499 7.53535 3.68595 7.89888L6.32197 10.6283Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmark-white.01b8d37c2c099ff800bc03f54f4f7e36.svg";
export { ForwardRef as ReactComponent };